import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "@/context/SessionProvider";

export const useSessionKeepAlive = () => {
    const navigate = useNavigate();
    const { refreshSession } = useSession();

    useEffect(() => {
        let id;

        const startInterval = () => {
            id = setInterval(async () => {
                // Solo refrescar si la ventana está visible
                if (document.hidden) return;

                const ok = await refreshSession();
                if (!ok) {
                    console.warn("Sesión expirada, redirigiendo…");
                    navigate("/", { replace: true });
                }
            }, 15 * 60 * 1000); // 15 min
        };

        startInterval();

        // Pausar/reanudar según visibilidad
        const handleVisibilityChange = () => {
            if (document.hidden) {
                clearInterval(id);
            } else {
                startInterval();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(id);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [refreshSession, navigate]);
};